const KDM = [
    {id: "0", value: "月K"},    
    {id: "1", value: "月D"}   
  ];  
  
  export default KDM